import { Badge, Space, Tooltip } from "antd";
import { ReactNode } from "react";

interface IMenuItemNotification {
    icon: ReactNode;
    text: string;
    badgeText?: ReactNode;
    badgeStatus?: "processing" | "success" | "error" | "default" | "warning";
}

const MenuItemNotification = ({ icon, text, badgeText, badgeStatus = "processing" }: IMenuItemNotification) => {
    return (
        <div className="flex-justify-space-between flex-align-center">
            <Space>
                {icon}
                {text}
            </Space>
            <div>
                {
                    badgeText ?
                        <Badge
                            count={badgeText}
                            status={badgeStatus}
                            style={{ marginTop: "-4px" }}
                        /> :
                        null
                }
            </div>
        </div>
    );
}

export default MenuItemNotification;